export enum WafRuleAction {
    Bypass = 'bypass',
    Deny = 'deny',
    Challenge = 'challenge',
    RateLimit = 'rateLimit',
    Redirect = 'redirect',
}
